/**
 * @fileoverview Shared Kind schema used by both frontend and backend.
 */

import { z } from 'zod';
import { createCrudSchemas, createDisplayableEntitySchema, getSchemaFields } from './base.js';
import { ID_PATTERNS } from './types.js';

export const KindSchema = createDisplayableEntitySchema(
  ID_PATTERNS.KIND,
  'ID must be in ki-prefixed nanoid7 format',
  { accountTracking: 'standard' }
);

const { CreateSchema, UpdateSchema } = createCrudSchemas(KindSchema);

export const KindCreateSchema = CreateSchema;
export const KindUpdateSchema = UpdateSchema;

export type Kind = z.infer<typeof KindSchema>;
export type KindCreate = z.infer<typeof KindCreateSchema>;
export type KindUpdate = z.infer<typeof KindUpdateSchema>;

export const KIND_FIELDS = getSchemaFields(KindSchema);
